// First month for $1: a Stripe trial of this length plus a one-time charge of this amount.
// Shared so checkout, the plan screen and the sign-up page quote the same terms.
export const INTRO_OFFER_CHARGE_CENTS = 100;
export const INTRO_OFFER_TRIAL_DAYS = 30;
// Plans above this many monthly events pay full price from day one, so $1 never buys a big month.
export const INTRO_OFFER_MAX_EVENT_BUCKET = 100_000;
